import React from "react";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";
import ContactList from "./ContactList";

interface Props {
  selectedContacts: server.dto.ContactSmallV2[]
  onChange: (newContacts: server.dto.ContactSmallV2[]) => void
}

const ContactMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedContacts}
    onRemove={props.onChange}
    getId={contact => contact.contactId}
    getLabel={contact => <div>
      {contact.name.fullName}
    </div>}
  >
    <ContactList
      onItemSelected={(item) => props.onChange([...props.selectedContacts, item])}
      excludeKeys={props.selectedContacts.map(cc => cc.contactId)}
    />
  </MultiPickerSelectedItems>;
};

export default ContactMultiPicker;